// @flow
import * as React from 'react';

type Props = {
  children: React.Node,
};

export default function ListContainer(props: Props): React.MixedElement {
  return (
    <div className="list-container">
      <div className="list-container__content">
        <div className="list-container__content-inner">{props.children}</div>
      </div>
    </div>
  );
}
